<template>
    <div>
      <van-sticky :offset-top="0">
        <demo-block :title="('')">
          <van-nav-bar :title="('个人用电情况')" :left-text="('返回')" left-arrow @click-left="this.$router.go(-1)">
            <template #right>
            
                <van-icon v-if="paytype===0 || paytype ===1" name="wechat-pay" size="18" />
                <van-icon v-if="paytype===2" name="alipay" size="18" />
             
            </template>
          </van-nav-bar>
        </demo-block>
         <!-- 时间筛选器 -->
        <div class="date-filter">
          <van-dropdown-menu>
            <van-dropdown-item v-model="timeRange" :options="timeOptions" @change="fetchData" />
          </van-dropdown-menu>
        </div>
      </van-sticky>
      <div class="container">
      <!-- 顶部标题栏 -->
      <van-cell-group v-if="isbind===true" title="内部信息" inset>
        <van-cell title="姓名" :value="userinfo.name+'['+userinfo.outid+']'" />
        <van-cell title="余额" :value="userinfo.oddfare"/>
    </van-cell-group>
     
      
      <!-- 统计卡片 -->
      <div class="section-title">核心指标</div>
        <div class="stats-grid">
            <div class="stat-card">
            <div class="stat-title">充电次数</div>
            <div class="stat-value">{{chargingData.sumcount}}</div>
            <div class="stat-subtitle">
              <van-icon :class="chargingData.sumcount>chargingData.sumcountlast?'success':'danger'" :name="chargingData.sumcount>chargingData.sumcountlast?'arrow-up':'arrow-down'" /> 
               <span :class="chargingData.sumcount>chargingData.sumcountlast?'success':'danger'"> 
                {{chargingData.sumcountlastinfo}} 
               </span>
            </div>
            </div>
            
            <div class="stat-card">
            <div class="stat-title">最高功率 (kW)</div>
            <div class="stat-value">{{chargingData.maxkw}}</div>
            <div class="stat-subtitle">
              <van-icon name="clock-o" /> {{chargingData.maxdwdate}}
            </div>
            </div>
            
            <div class="stat-card">
            <div class="stat-title">最早充电时间</div>
            <div class="stat-value">{{chargingData.earlytime}}</div>
            <div class="stat-subtitle">
                <van-icon name="clock-o" /> {{chargingData.earlydate}}
            </div>
            </div>
            
            <div class="stat-card">
            <div class="stat-title">最晚充电时间</div>
            <div class="stat-value">{{chargingData.latertime}}</div>
            <div class="stat-subtitle">
                <van-icon name="clock-o" /> {{chargingData.laterdate}}
            </div>
            </div>
            
            <div class="stat-card">
            <div class="stat-title">平均时长</div>
            <div class="stat-value">{{chargingData.avetime}}小时</div>
            <div class="stat-subtitle">
                <van-icon name="clock-o" class="danger" /> {{chargingData.lastavetime}}
            </div>
            </div>
            
            <div class="stat-card">
            <div class="stat-title">最长充电</div>
            <div class="stat-value">{{chargingData.maxtime}}小时</div>
            <div class="stat-subtitle">
                <van-icon name="clock-o" /> {{chargingData.maxtimedate}}
            </div>
            </div>
        </div>
        
        <!-- 充电次数趋势图 -->
        <div class="section-title">充电趋势分析</div>
        <div class="chart-container">
            <div class="chart-header">
            <div class="chart-title">每月充电次数</div>
            <div class="chart-actions">
                <van-icon name="arrow-down" />
            </div>
            </div>
            <div id="trendChart" class="chart"></div>
        </div>
        
        <!-- 充电时段分布 -->
        <div class="section-title">充电时段分布</div>
        <div class="time-distribution">
            <div class="time-card">
            <div class="time-title">凌晨 (00-06)</div>
            <div class="time-value">{{chargingData.workcountpercent1}}%</div>
            </div>
            <div class="time-card">
            <div class="time-title">上午 (06-12)</div>
            <div class="time-value">{{chargingData.workcountpercent2}}%</div>
            </div>
            <div class="time-card">
            <div class="time-title">下午 (12-18)</div>
            <div class="time-value">{{chargingData.workcountpercent3}}%</div>
            </div>
            <div class="time-card">
            <div class="time-title">晚上 (18-24)</div>
            <div class="time-value">{{chargingData.workcountpercent4}}%</div>
            </div>
        </div>
        
        <!-- 功率分布图 -->
        <div class="chart-container">
            <div class="chart-header">
            <div class="chart-title">充电功率分布</div>
            <div class="chart-actions">
                <van-icon name="filter-o" />
            </div>
            </div>
            <div id="powerChart" class="chart"></div>
        </div>
        
        <!-- 用户行为分析 -->
        <div class="section-title">用户行为分析</div>
        <div class="user-behavior">
            <div class="behavior-item">
            <div class="behavior-title">平均每周充电次数</div>
            <div class="behavior-value">{{chargingData.avetime}}次</div>
            </div>
            <div class="behavior-item">
            <div class="behavior-title">高峰日充电量</div>
            <div class="behavior-value">{{chargingData.sumkwweekname}}</div>
            </div>
            <div class="behavior-item">
            <div class="behavior-title">常用充电时段</div>
            <div class="behavior-value">{{chargingData.normalworktime}}</div>
            </div>
            <div class="behavior-item">
            <div class="behavior-title">平均单次充电量</div>
            <div class="behavior-value">{{chargingData.avekw}} kWh</div>
            </div>
        </div>
        </div>
      
      <van-overlay :show="isLoading" >
        <view class="wrapper">
          <view class="block" catch:tap="noop">
            <van-loading size="24px" color="#ffffff">{{loadcontent}}</van-loading>
          </view>
        </view>
      </van-overlay>
    </div>
  </template>
  
  <script>
  import { DropdownMenu, DropdownItem, ActionSheet, Divider, PullRefresh, Cell,CellGroup,Checkbox, Button, Dialog, CheckboxGroup, Card, SubmitBar, Toast, Tabs, Tab, Sticky, NavBar, Icon, Tag,  Overlay, Loading } from 'vant';
  import { requestGetChargeChartData } from '../../api/api'
  import { mapState, mapGetters, mapActions } from 'vuex'
  import { GetBrowserType } from '../../utils/tools/index'
  //import F2 from "@antv/f2";
  export default {
    components: {
      [Button.name]: Button,
      [Card.name]: Card,
      [Checkbox.name]: Checkbox,
      [SubmitBar.name]: SubmitBar,
      [CheckboxGroup.name]: CheckboxGroup,
      [Sticky.name]: Sticky,
      [NavBar.name]: NavBar,
      [Icon.name]: Icon,
      [Tabs.name]: Tabs,
      [Tab.name]: Tab,
      [Tag.name]:Tag,
      [Dialog.name]: Dialog,
      [Overlay.name]: Overlay,
      [Loading.name]: Loading,
      [Cell.name]: Cell,
      [CellGroup.name]: CellGroup,
      [PullRefresh.name]:PullRefresh,
      [Divider.name]: Divider,
      [ActionSheet.name]: ActionSheet,
      [Toast.name]: Toast,
      [DropdownMenu.name]: DropdownMenu,
      [DropdownItem.name]: DropdownItem,
    },
    computed: {
      ...mapState({
        token: state => state.token,
        isbind: state => state.isbind,
        userinfo: state => state.userinfo,
        accesstoken: state => state.accesstoken,
        openid: state => state.openid,
        typekey: state => state.typekey
      }),
      ...mapGetters([
        'openidex',
        'hasopenid',
        'isReAuthLogin',
        'isGrid'
      ])
    },
    data() {
      return {
        paytype: 0,
        fromid: 1,
        toid: 5,
        listCount: 5,
        finished: false,
        loadcontent: '加载中...',
        isLoading: false,
        active: 0,
        lscurorder: [],
        lsorder: [],
        ordertype: [
          { id: 0, key: "all", title: "在充订单", icon: "wap-home" }
        ],
        nTimeDelayInternal: null,
        timeDelay: 60,
        showChart: false,
        timeRange: 0,
        timeOptions: [
          { text: '近一周', value: 0 },
          { text: '近一个月', value: 1 },
          { text: '近半年', value: 2 },
          { text: '近一年', value: 3 }
        ],
        chargingData: {},
        chargingList: [],
        loading: false
      }
    },
    watch: {
      active(val) {
        console.log('获得的active发生变化：' + val);
      },
    },
    mounted() {
        this.paytype=(GetBrowserType())
        console.log(this.getLocalLoginInfo())
        this.fetchData();
    },
    methods: {
      ...mapActions([
        'getLocalLoginInfo',
        'getIsNeedAuthLogin',
        'clearAccessToken',
        'getBaseUserInfo'
      ]),
      onLoad() {
        this.isLoading = true
        
      },
      onRefresh() {
      },
      async fetchData() {
          // 模拟数据加载
        this.isLoading = true;
        const res = await requestGetChargeChartData({accesstoken: this.$store.state.accesstoken, dttype: this.timeRange, startdt: '2000-1-1', enddt: '2099-12-31'})
        if (res.return_code ==0) {
          if (res.data.length<=0) {
            Dialog.alert({
              title: '信息提醒',
              message: '没有有效数据，请使用之后再使用此功能！',
            })
            setTimeout(() => {
              this.$router.push('#/chargeindex?t1=' + new Date().getTime());
            }, 300);
            return
          }
          this.chargingList = res.data
          this.chargingData = res.data[0]
          setTimeout(() => {
            this.initCharts();
            this.isLoading = false;
          }, 800);
        } else {
          Dialog.alert({
            title: '错误提醒',
            message: '获取数据失败：' + res.return_message,
          })
          setTimeout(() => {
            this.$router.push('#/chargeindex?t1=' + new Date().getTime());
          }, 300);
          return
        }        
      },
      initCharts() {
          // 初始化趋势图表
          var _data = ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月']
          var _value = [85, 92, 104, 118, 124, 132, 145, 152, 148, 138, 126, 110]
          var _list = [
            { value: 25, name: '0-30kW' },
            { value: 35, name: '30-60kW' },
            { value: 28, name: '60-90kW' },
            { value: 120, name: '90kW+' }
          ]
          _data = []
          _value = []
          _list = []
          this.chargingList.forEach((i, index) => {
            _data.push(i.dtmonth)
            _value.push(i.monthsumcount)
            if (index==0) {
              if (i.workpowerpercent1>0) _list.push({value: i.workpowerpercent1, name: i.workpower1})
              if (i.workpowerpercent2>0) _list.push({value: i.workpowerpercent2, name: i.workpower2})
              if (i.workpowerpercent3>0) _list.push({value: i.workpowerpercent3, name: i.workpower3})
              if (i.workpowerpercent4>0) _list.push({value: i.workpowerpercent4, name: i.workpower4})
            }
          });
          console.log(_list)

          const trendChart = window.echarts.init(document.getElementById('trendChart'));
          trendChart.setOption({
          tooltip: {
              trigger: 'axis'
          },
          grid: {
              left: '3%',
              right: '4%',
              bottom: '3%',
              top: '5%',
              containLabel: true
          },
          xAxis: {
              type: 'category',
              data: _data,
              axisLine: {
              lineStyle: {
                  color: '#eee'
              }
              },
              axisLabel: {
              color: '#666'
              }
          },
          yAxis: {
              type: 'value',
              axisLine: {
              show: false
              },
              axisLabel: {
              color: '#666'
              },
              splitLine: {
              lineStyle: {
                  color: '#f5f5f5'
              }
              }
          },
          series: [{
              data: _value,
              type: 'line',
              smooth: true,
              symbol: 'circle',
              symbolSize: 8,
              lineStyle: {
              width: 3,
              color: '#1989fa'
              },
              itemStyle: {
              color: '#1989fa'
              },
              areaStyle: {
              color: {
                  type: 'linear',
                  x: 0, y: 0, x2: 0, y2: 1,
                  colorStops: [{
                  offset: 0, color: 'rgba(25, 137, 250, 0.3)'
                  }, {
                  offset: 1, color: 'rgba(25, 137, 250, 0.05)'
                  }]
              }
              }
          }]
          });
          
          // 初始化功率分布图
          const powerChart = window.echarts.init(document.getElementById('powerChart'));
          powerChart.setOption({
          tooltip: {
              trigger: 'item'
          },
          legend: {
              bottom: 0,
              left: 'center',
              textStyle: {
              color: '#666'
              }
          },
          color: ['#07c160', '#1989fa', '#ff976a', '#ee0a24'],
          series: [{
              name: '功率分布',
              type: 'pie',
              radius: ['40%', '70%'],
              center: ['50%', '40%'],
              avoidLabelOverlap: false,
              itemStyle: {
              borderRadius: 10,
              borderColor: '#fff',
              borderWidth: 2
              },
              label: {
              show: false
              },
              emphasis: {
              label: {
                  show: true,
                  fontSize: '14',
                  fontWeight: 'bold'
              }
              },
              labelLine: {
              show: false
              },
              data: _list
          }]
          });
          
          // 响应式调整
          window.addEventListener('resize', function() {
            trendChart.resize();
            powerChart.resize();
          });
      }
    }
  };
  </script>
  
  <style lang="less">
  .wrapper {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
    }
  .card-goods {
    padding: 10px 0;
    background-color: #fff;
  
    &__item {
      position: relative;
      background-color: #fafafa;
  
      .van-checkbox__label {
        width: 100%;
        height: auto; // temp
        padding: 0 10px 0 15px;
        box-sizing: border-box;
      }
  
      .van-checkbox__icon {
        top: 50%;
        left: 10px;
        z-index: 1;
        position: absolute;
        margin-top: -10px;
      }
  
      .van-card__price {
        color: #f44;
      }
    }
  }
  .content {
      padding: 5px 5px 150px;
    }
 
    * {
      margin: 0;
      padding: 0;
      box-sizing: border-box;
      -webkit-tap-highlight-color: transparent;
    }
    
    body {
      font-family: "PingFang SC", "Helvetica Neue", Arial, sans-serif;
      background-color: #f5f7fa;
      color: #333;
      padding-bottom: 50px;
      max-width: 100%;
      overflow-x: hidden;
    }
    
    .container {
      max-width: 100%;
      padding: 12px;
    }
    
    .header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 15px 0;
      margin-bottom: 10px;
    }
    
    .header h1 {
      font-size: 20px;
      font-weight: bold;
      color: #1a1a1a;
    }
    
    .user-info {
      display: flex;
      align-items: center;
    }
    
    .user-avatar {
      width: 36px;
      height: 36px;
      border-radius: 50%;
      background-color: #07c160;
      display: flex;
      align-items: center;
      justify-content: center;
      color: white;
      font-weight: bold;
      font-size: 10px;
      margin-left: 10px;
    }
    
    .date-filter {
      background-color: white;
      border-radius: 12px;
      padding: 15px;
      margin-bottom: 15px;
      box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
    }
    
    .stats-grid {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 12px;
      margin-bottom: 15px;
    }
    
    .stat-card {
      background: white;
      border-radius: 12px;
      padding: 16px;
      box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
    }
    
    .stat-title {
      font-size: 13px;
      color: #999;
      margin-bottom: 8px;
    }
    
    .stat-value {
      font-size: 22px;
      font-weight: bold;
      color: #1a1a1a;
      margin-bottom: 4px;
    }
    
    .stat-subtitle {
      font-size: 12px;
      color: #07c160;
      display: flex;
      align-items: center;
    }
    
    .chart-container {
      background: white;
      border-radius: 12px;
      padding: 16px;
      margin-bottom: 15px;
      box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
      height: 280px;
    }
    
    .chart-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 15px;
    }
    
    .chart-title {
      font-size: 16px;
      font-weight: bold;
    }
    
    .chart-actions {
      display: flex;
    }
    
    .chart {
      height: 230px;
      width: 100%;
    }
    
    .section-title {
      font-size: 18px;
      font-weight: bold;
      margin: 20px 0 15px;
      padding-left: 5px;
      position: relative;
    }
    
    .section-title::before {
      content: "";
      position: absolute;
      left: 0;
      top: 5px;
      height: 16px;
      width: 4px;
      background-color: #07c160;
      border-radius: 2px;
    }
    
    .time-distribution {
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      gap: 10px;
      margin-bottom: 15px;
    }
    
    .time-card {
      background: white;
      border-radius: 12px;
      padding: 15px;
      text-align: center;
      box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
    }
    
    .time-title {
      font-size: 13px;
      color: #666;
      margin-bottom: 8px;
    }
    
    .time-value {
      font-size: 18px;
      font-weight: bold;
      color: #1a1a1a;
    }
    
    .user-behavior {
      background: white;
      border-radius: 12px;
      padding: 16px;
      box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
    }
    
    .behavior-item {
      display: flex;
      justify-content: space-between;
      padding: 12px 0;
      border-bottom: 1px solid #eee;
    }
    
    .behavior-item:last-child {
      border-bottom: none;
    }
    
    .behavior-title {
      font-size: 14px;
      color: #333;
    }
    
    .behavior-value {
      font-size: 14px;
      font-weight: 500;
      color: #07c160;
    }
    
    .loading {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 200px;
    }
    
    .empty-data {
      text-align: center;
      padding: 40px 0;
      color: #999;
    }
    
    .highlight {
      color: #1989fa;
    }
    
    .danger {
      color: #ee0a24;
    }
    
    .warning {
      color: #ff976a;
    }
    
    .success {
      color: #07c160;
    }
   

  </style>
  